module.exports = __webpack_public_path__ + "static/media/costco-small_2x.8d327338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/costco-small_2x.png
// module id = 682
// module chunks = 27